import React from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import { ROUTES } from 'constants/routes';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';
import Images from 'config/assets';

import stylesJS from './styles';
import styles from './styles.module.scss';

class PublicHome extends React.PureComponent {
  handleSignUp = () => {
    this.props.dispatch(push(ROUTES.SIGN_UP));
  };

  render() {
    return (
      <div style={stylesJS.container}>
        {appConfig.publicHomeWithLogo && <img src={Images.topbarLogo} style={stylesJS.fullLogo} alt="logo" />}
        <div style={stylesJS.textContainer}>
          {!appConfig.publicHomeWithLogo && (
            <img src={Images.topbarLogo} style={stylesJS.utilityLogo} alt="logo" />
          )}
          <div style={stylesJS.subtitle}>
            <UTLabel extrabold>{message('Home:subtitle')}</UTLabel>
          </div>
          <div style={stylesJS.list}>
            {appConfig.publicHomePage.map(item => (
              <UTLabel key={item.content} style={stylesJS.listItem}>
                {item.content}
              </UTLabel>
            ))}
          </div>
          {appConfig.publicHomeWithRegister && (
            <UTButton className={styles.registerButton} onPress={this.handleSignUp}>
              {message('Home:register')}
            </UTButton>
          )}
        </div>
      </div>
    );
  }
}

export default connect()(Radium(PublicHome));
